export default "__VITE_PUBLIC_ASSET__2415b698__"